/*
 * 研究自选股生命周期 HTTP 服务 / Research watchlist lifecycle HTTP service.
 *
 * 浏览器只调用 BFF 的 /api/research/watchlists/* 合同；这里不保存业务状态、
 * 不推导 CoverageCase/TrackingRecord，也不兼容旧 /api/watchlist 写接口。
 */
import { request } from '@umijs/max';

const REQUEST_OPTIONS = {
  credentials: 'include',
};

export const getResearchWatchlistWorkbench = params => request(
  '/api/research/watchlists/workbench',
  { ...REQUEST_OPTIONS, params },
);

export const searchResearchSecurities = params => request(
  '/api/research/watchlists/securities/search',
  { ...REQUEST_OPTIONS, params },
);

export const getResearchNomination = id => request(
  `/api/research/watchlists/nominations/${encodeURIComponent(id)}`,
  REQUEST_OPTIONS,
);

export const getResearchStockQuickPreview = params => request(
  '/api/research/watchlists/quick-preview',
  { ...REQUEST_OPTIONS, params },
);

export const getResearchWatchlistQuotes = symbols => request(
  '/api/research/watchlists/quotes',
  {
    ...REQUEST_OPTIONS,
    params: { symbols: symbols.join(',') },
  },
);

export const getResearchWatchlistMiniKlines = symbols => request(
  '/api/research/watchlists/mini-klines',
  {
    ...REQUEST_OPTIONS,
    params: {
      symbols: symbols.join(','),
      resolution: 'D',
      bars: 120,
    },
  },
);

export const createResearchNomination = data => request(
  '/api/research/watchlists/nominations',
  { ...REQUEST_OPTIONS, method: 'POST', data },
);

export const submitResearchNomination = (id, expectedVersion) => request(
  `/api/research/watchlists/nominations/${encodeURIComponent(id)}/submit`,
  {
    ...REQUEST_OPTIONS,
    method: 'POST',
    data: { expectedVersion },
  },
);

export const withdrawResearchNomination = (id, expectedVersion) => request(
  `/api/research/watchlists/nominations/${encodeURIComponent(id)}/withdraw`,
  {
    ...REQUEST_OPTIONS,
    method: 'POST',
    data: { expectedVersion },
  },
);

export const getResearchStrategyDraftSources = () => request(
  '/api/research/watchlists/nomination-drafts/strategy-sources',
  REQUEST_OPTIONS,
);

export const importResearchStrategyDrafts = sourceRef => request(
  '/api/research/watchlists/nomination-drafts/import-strategy',
  {
    ...REQUEST_OPTIONS,
    method: 'POST',
    data: { sourceRef },
  },
);
